import type { ICategory } from "app/common/services/categoryService.types";
import type {
    ICategoryLeadersTableQueryParams,
    ICategoryLeadersTableSort,
} from "app/pages/industry-analysis/category-leaders/components/CategoryLeadersTable/CategoryLeadersTable.shared.types";
import type { IColumnsPickerLiteProps } from "@similarweb/ui-components";
import type { ICategoryLeadersServices } from "app/pages/industry-analysis/category-leaders/CategoryLeaders.types";

export const createTableSearchFilter = (filterKey: string, filterTerm) => {
    return filterTerm ? `${filterKey};contains;"${filterTerm.trim()}"` : "";
};

export const createTableDataFilter = (filterKey: string, filterValue: number) => {
    const hasValue = typeof filterValue !== "undefined" && filterValue !== null;
    return hasValue ? `${filterKey};==;${filterValue}` : "";
};

export const combineTableFilters = (searchFilter: string, dataFilter: string) => {
    return [searchFilter, dataFilter].filter((filter) => filter.length > 0).join(",");
};

export const getTableExcelUrl = (props: {
    apiEndpoint: string;
    tableQueryParams: ICategoryLeadersTableQueryParams;
    tableFilter: string;
    tableSort: ICategoryLeadersTableSort;
    category: ICategory;
    services: ICategoryLeadersServices;
}) => {
    const queryParams = getTableQueryParamsForExcel(props);
    return `${props.apiEndpoint}?${queryParams}`;
};

const getTableQueryParamsForExcel = (props: {
    tableQueryParams: ICategoryLeadersTableQueryParams;
    tableFilter: string;
    tableSort: ICategoryLeadersTableSort;
    category: ICategory;
    services: ICategoryLeadersServices;
}) => {
    const { tableFilter, tableQueryParams, category, tableSort, services } = props;
    const filterParam = tableFilter ? { filter: tableFilter } : {};

    const queryParams = services.fetchService.requestParams({
        ...tableQueryParams,
        ...filterParam,
        category: category?.forDisplayApi,
        orderBy: `${tableSort.field} ${tableSort.sortDirection}`,
    });

    return queryParams;
};

export const getColumnsPickerLiteProps = (
    tableColumns: any[],
    onClickToggleColumns: (index: any) => void,
): Omit<IColumnsPickerLiteProps, "translations"> => {
    const columns = tableColumns.reduce((res, col, index) => {
        if (!col.fixed) {
            return [
                ...res,
                {
                    key: index.toString(),
                    displayName: col.displayName,
                    visible: col.visible,
                },
            ];
        }
        return res;
    }, []);
    return {
        columns,
        onColumnToggle: (key) => {
            // tslint:disable-next-line:radix
            onClickToggleColumns(parseInt(key));
        },
        onPickerToggle: () => null,
    };
};
